import React from 'react';
import { useLocation } from 'react-router';
import { Button, ButtonProps } from '../Button';
import { Container } from './styles';

const propShape = ['default', 'round'] as const;
type PropShapeType = typeof propShape[number];

export interface SegmentedControlProps {
  children: JSX.Element[];
  shape?: PropShapeType;
}

export interface ItemProps extends ButtonProps {
  isCurrentActive?: boolean;
  currentActiveView?: ButtonProps['view'];
  to?: string;
}

export function SegmentedControl({ children, shape = 'default', ...other }: SegmentedControlProps) {
  const view: ButtonProps['view'] = shape === 'round' ? 'transparent' : 'extra-dim';
  const currentActiveView: ButtonProps['view'] =
    shape === 'round' ? 'regular-shadow' : 'primary-dim';

  return (
    <Container shape={shape} {...other}>
      {React.Children.map(children, button =>
        React.cloneElement(button, { view, currentActiveView, shape })
      )}
    </Container>
  );
}

SegmentedControl.Item = (props: ItemProps) => {
  const { children, currentActiveView, ...other } = props;
  const { pathname } = useLocation();

  let view: ButtonProps['view'] = pathname === props.to ? currentActiveView : props.view;
  let isHover = pathname !== props.to;

  if (typeof props.isCurrentActive === 'boolean') {
    view = props.isCurrentActive ? currentActiveView : props.view;
    isHover = !props.isCurrentActive;
  }

  return (
    <Button {...other} view={view} isHover={isHover}>
      {children}
    </Button>
  );
};

export { propShape as segmentedControlPropShape };
export type { PropShapeType as SegmentedControlPropShapeType };
